<div class="custom-dropdown">
  <div class="input-filtro-selecionado">
    <button type="button" class="dropdown-toggle" (click)="toggleResponsavel()">
      <img
        src="{{ BASE_IMG_URL }}assets/agenda-tarefas/user.svg"
      />
      {{
        filtroResponsavel === "Todos"
          ? "Todos os responsáveis"
          : nomeResponsavelSelecionado
      }}
    </button>
    <button
      *ngIf="filtroResponsavel !== 'Todos' && !ocultarTodos"
      type="button"
      class="btn-clear"
      (click)="limparResponsavel()"
    >
      ×
    </button>
  </div>
  <div *ngIf="mostrarResponsavel" class="dropdown-list">
    <ng-container *ngIf="!ocultarTodos; else apenasUm">
      <label>
        <input
          type="radio"
          name="responsavel"
          value="Todos"
          [(ngModel)]="filtroResponsavel"
          (change)="onResponsavelChange()"
        />
        Todos
      </label>
      <label *ngFor="let r of responsavel">
        <input
          type="radio"
          name="responsavel"
          [value]="r.id"
          [(ngModel)]="filtroResponsavel"
          (change)="onResponsavelChange()"
        />
        {{ r?.name }}
      </label>
    </ng-container>
    <ng-template #apenasUm>
      <label *ngFor="let r of responsavel">
        <input
          type="radio"
          name="responsavel"
          [value]="r.id"
          [(ngModel)]="filtroResponsavel"
          checked
          disabled
        />
        {{ r?.name }}
      </label>
    </ng-template>
  </div>
</div>
